import { useQuery } from 'react-query'

import getGamePairingCandidates from '../../../../../Apis/teamPairings/getGamePairingCandidates'
import useGetLocalStorage from '../../../../../hooks/useGetLocalStorage'
import localStorageIds from '../../../../../utils/constants/localStorageIds'

export const getClubTeamId = (team) => team?.teamId ?? team?.id ?? null

// Fetches the federation games a club game can connect to, merges any already-connected (possibly
// past) game back in, and sorts by season. Returns [] when there's nothing to show so the caller
// can hide the field entirely — avoiding an empty form row (FormContainer pads every child).
const useGamePairingCandidates = ({ clubTeamId, existingPairedGame, enabled }) => {
  const localStorageValue = useGetLocalStorage()
  const { [localStorageIds.SELECTED_ORG]: selectedOrg } = localStorageValue || {}
  const orgId = selectedOrg?.id

  const { data: candidates = [] } = useQuery(
    ['gamePairingCandidates', orgId, clubTeamId],
    () => getGamePairingCandidates(orgId, clubTeamId),
    { enabled: Boolean(enabled && orgId && clubTeamId) },
  )

  const options = [...candidates]
  if (
    existingPairedGame &&
    !options.some((game) => game.gameEventId === existingPairedGame.gameEventId)
  ) {
    options.unshift(existingPairedGame)
  }

  // Sorted by competition/season so the modal renders contiguous season groups.
  options.sort((a, b) => {
    const bySeason = (a.seasonName ?? '').localeCompare(b.seasonName ?? '')
    if (bySeason !== 0) return bySeason
    return new Date(a.startDateTime) - new Date(b.startDateTime)
  })

  return options
}

export default useGamePairingCandidates
